import React, { useEffect, useState } from "react";
import "style/MarketSimulation.scss";

import { Link } from "react-router-dom";

import en from "../config/i18n/english/english";
import legacy from "config/i18n/legacy";
import useLang, { resolveLang } from "hooks/useLang";
import landing from "config/i18n/landing";
import ui from "config/i18n/ui";

import Rakete from "assets/video/Rakete.mp4";
import RaketeS from "assets/video/RaketeS.mp4";

import usePageTitle from "hooks/usePageTitle";

import FeatureCards from "components/FeatureCards";
import Plan from "components/Plan";
import Reveal from "components/Reveal";
import { GapBadge, MlCircles } from "components/MarksimArt";
import MarksimInsights from "components/MarksimInsights";


const MarketSimulation = () => {
  const [language, setLanguage] = useState<any>(en);
  const lang = useLang();
  usePageTitle(landing[lang].nav.marksim);
  const art = ui[lang].art;

  useEffect(() => {
    setLanguage(legacy[resolveLang()]);
  }, []);

  const home = language.homepage;
  const plans = language.Plans;

  return (
    <div className="homepage">
      <header className="hero">
        <div className="hero__media" aria-hidden="true">
          <video
            className="hero__video hero__video--desktop"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          >
            <source src={Rakete} type="video/mp4" />
          </video>
          <video
            className="hero__video hero__video--mobile"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          >
            <source src={RaketeS} type="video/mp4" />
          </video>
          <div className="hero__overlay" />
        </div>

        <div className="hero__inner shell">
          <div className="hero__copy">
            <h1 className="hero__title">
              {home.headerTitle1st}
              <br />
              <span className="text-gradient">{home.headerTitle2st}</span>
            </h1>
            <p className="hero__lead">
              <strong>{home.headerDescriptionFirst[0]}</strong>{" "}
              {home.headerDescriptionFirst[1]}{" "}
              <strong>{home.headerDescriptionFirst[2]}</strong>{" "}
              {home.headerDescriptionFirst[3]}
            </p>
            <div className="hero__actions">
              <a className="btn btn--primary" href="#plans">
                {plans.plan_information_text[0]}
              </a>
              <Link className="btn btn--ghost" to="/contact">
                {language.dropdown.contact}
              </Link>
            </div>
          </div>

          <div className="hero__diagram" aria-hidden="true">
            <GapBadge lines={art.gap} />
          </div>
        </div>

        <a
          className="hero__scroll"
          href="#learn-more"
          aria-hidden="true"
          tabIndex={-1}
        >
          <span />
        </a>
      </header>

      <main>
        <section className="intro" id="learn-more">
          <div className="shell intro__grid">
            <Reveal className="intro__copy">
              <h2 className="intro__title">
                {home.bodyFooterContent[0]}{" "}
                <span className="accent">{home.bodyFooterContent[1]}</span>{" "}
                {home.bodyFooterContent[2]} {home.bodyFooterContent[3]}{" "}
                <span className="accent">{home.bodyFooterContent[4]}</span>
              </h2>
              <p>
                {home.headerDescriptionSecond[0]}{" "}
                <Link className="intro__link" to="/contact">
                  {home.headerDescriptionSecond[1]}
                </Link>
              </p>
            </Reveal>
            <Reveal className="intro__art" delay={120}>
              <MlCircles lines={art.ml} />
            </Reveal>
          </div>
        </section>

        <section className="features">
          <div className="shell">
            <Reveal className="section-head">
              <h2>
                <span className="accent">{home.bodyHeader[0]}</span>{" "}
                {home.bodyHeader[1]}
              </h2>
            </Reveal>
            <FeatureCards items={home.bodyHeaderContent} />
          </div>
        </section>

        <MarksimInsights />

        <section className="plans" id="plans">
          <div className="shell">
            <Reveal className="section-head">
              <h2>
                {home.bodyFooterChoosePlan[0]}{" "}
                <span className="accent">{home.bodyFooterChoosePlan[1]}</span>
              </h2>
            </Reveal>
            <Plan
              items={plans.plan}
              planDescription={plans.plan_description}
              planInfoText={plans.plan_information_text}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default MarketSimulation;
